import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { UnstyledLink } from '@egr/xbox/egr-gui-elements/single-components/UnstyledLink';
import { WarningIcon } from '@egr/xbox/egr-gui-icons/WarningIcon';
import { makeStyles } from '@egr/xbox/utils/tss-react';

const useNoWebGLStyles = makeStyles({ name: 'NoWebGL' })((theme) => ({
    root: {
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: theme.palette.background.default,
    },
    sub: {
        textAlign: 'center',
    },
    icon: {
        color: theme.palette.error.main,
        width: '2em',
        height: '2em',
        marginBottom: theme.spacing(2)
    }
}));

export const NoWebGL: React.FC = React.memo(
    () => {
        const { classes } = useNoWebGLStyles();

        const { t } = useTranslation();

        return (
            <Modal open={true}>
                <div className={classes.root}>
                    <div className={classes.sub}>
                        <WarningIcon className={classes.icon}/>
                        <br/>
                        <Typography color="error" variant="h5">{t('WebGL required')}</Typography>
                        <br/>
                        <Typography>{t('This application requires WebGL. Please use a WebGL-compatible Browser.')}</Typography>
                        <br/>
                        <UnstyledLink href="http://get.webgl.org/" target="_blank">
                            <Typography color="primary">{t('Click here to get further information.')}</Typography>
                        </UnstyledLink>
                    </div>
                </div>
            </Modal>
        );
    }
);